import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";

import jsBridge from "@/utils/jsbridge";
import dsBridge from "@/utils/dsbridge";

import Home from "@/views/home";
import Search from "@/views/search";
import SearchKnowledge from "@/views/search/searchKnowledge";
import SearchFellow from "@/views/search/searchFellow";
import FAQDetail from "@/views/faqDetail";
import KnowledgeDetail from "@/views/knowledgeDetail";
import sourceView from "@/views/sourceView";
import treeMenu from "@/views/treeMenu/treeMenu";
import favorites from "@/views/favorites/favorites";
import message from "@/views/message/message";
import follow from "@/views/follow/follow";
import mine from "@/views/mine/mine";
import service from "@/views/2500/service";

import unauthorized from "@/views/404/403";

import FAQList from "@/views/search/faqList";
import KnowledgeList from "@/views/search/knowledgeList";
import AttachmentList from "@/views/search/attachmentList";
import SelectCity from "@/views/selectCity";
import Construct from "@/components/construct";
import Feedback from "@/views/feedback";
import Contacts from "@/views/contactEntire";
import NewUpdate from "@/views/newUpdate";
import OrderData from "@/views/orderData";
import MyAssets from "@/views/myAssets";
import RecentDailyReport from "@/views/recentDailyReport";
import LatestDetail from "@/views/latestDetail";
import ReplyList from "@/views/replyList";
import LeaveQuestion from "@/components/leaveQuestion";

import { appAuth, userAuth, isWeixinCient } from "@/utils/userAuth";

import { COMMON } from '@/api'


Vue.use(Router);

export const constantRouterMap = [
    {
        path: "/",
        name: "default",
        redirect: "/home"
    },
    {
        path: "/home",
        name: "home",
        meta: {
            keepAlive: true
        },
        component: Home
    },
    {
        path: "/treeMenu",
        name: "treeMenu",
        component: treeMenu
    },
    {
        path: "/search",
        name: "search",
        meta: {
            keepAlive: true
        },
        component: Search,
        children: [{
                path: "knowledge",
                name: "searchKnowledge",
                component: SearchKnowledge
            },
            {
                path: "fellow",
                name: "searchFellow",
                component: SearchFellow
            },
            {
                path: "faqList",
                name: "faqList",
                meta: {
                    title: "搜索内容"
                },
                component: FAQList
            },
            {
                path: "knowledgeList",
                name: "knowledgeList",
                meta: {
                    title: "搜索内容"
                },
                component: KnowledgeList
            },
            {
                path: "attachmentList",
                name: "attachmentList",
                meta: {
                    title: "搜索内容"
                },
                component: AttachmentList
            },
        ]
    },
    {
        path: "/faq/:uuid/:commentId?",
        name: "faq",
        meta: {
            keepAlive: true
        },
        component: FAQDetail
    },
    {
        path: "/knowledge/:uuid/:commentId?/:subCommentId?",
        name: "knowledge",
        meta: {
            keepAlive: true
        },
        component: KnowledgeDetail
    },
    {
        path: "/sourceView",
        name: "sourceView",
        component: sourceView
    },
    {
        path: "/construct",
        name: "construct",
        component: Construct
    },
    {
        path: '/sendMail',
        name: 'sendMail',
        component: () => import('@/views/sendMail')
    },
    {
        path: "/feedback/:from",
        name: "feedback",
        meta: {
            keepAlive: true
        },
        component: Feedback
    },
    {
        path: "/selectCity",
        name: "selectCity",
        component: SelectCity
    },
    {
        path: "/contacts",
        name: "contacts",
        component: Contacts
    },
    {
        path: "/newUpdate/:uuId",
        name: "newUpdate",
        component: NewUpdate
    },
    {
        path: "/orderData",
        name: "orderData",
        component: OrderData
    },
    {
        path: "/myAssets",
        name: "myAssets",
        component: MyAssets
    },
    {
        path: "/latestDetail/:uuid",
        name: "latestDetail",
        meta: {
            keepAlive: false
        },
        component: LatestDetail
    },
    {
        path: "/recentDailyReport",
        name: "recentDailyReport",
        meta: {
            keepAlive: false
        },
        component: RecentDailyReport
    },
    {
        path: "/favorites",
        name: "favorites",
        component: favorites
    },
    {
        path: "/message",
        name: "message",
        component: message
    },
    {
        path: "/follow",
        name: "follow",
        component: follow
    },
    {
        path: "/mine",
        name: "mine",
        component: mine
    },
    {
        path: "/service",
        name: "service",
        component: service
    },
    {
        path: "/allRecovery/:commentId/:uuid/:matchCommentId?",
        name: "replyList",
        meta: {
            keepAlive: false
        },
        component: ReplyList
    },
    {
        path: "/leaveQuestion",
        name: "leaveQuestion",
        meta: {
            keepAlive: false
        },
        component: LeaveQuestion
    },
    {
        path: "/unauthorized",
        name: "unauthorized",
        meta: {
            keepAlive: false
        },
        component: unauthorized
    }
];

export const ROUTE = new Router({
    routes: constantRouterMap
});

const userInfoMTA = () =>{
    setTimeout(() => {
        try{
            MtaH5.clickStat('userInfo',{'adacount':localStorage.ADAccount,'phone':localStorage.Mobile,'email':localStorage.Email,'origin':localStorage.AUTH_TYPE})
            console.log('统计用户信息成功');
        }
        catch(err){
            console.log(err);
        }
    }, 500);
}

function GetDebugAuthUrl() {
    // 调取过鉴权Url 不再调用
    // 后期可能需要去掉此判断 Debug那边会迭代更新鉴权信息有效期
    if (localStorage.Help_Debug_AuthAppId !== undefined && localStorage.Help_Debug_AuthSign !== undefined) return
    COMMON.DebugAuthUrl().then((res) => {
        if (res && res.Data) {
            localStorage.Help_Debug_AuthAppId = res.Data.AppId
            localStorage.Help_Debug_AuthSign = res.Data.Sign
        }
    })
}

ROUTE.beforeEach((to, from, next) => {

    // Toolkit(Mate) AUTH
    if (jsBridge && jsBridge.call("toolkit.getTokenSyn")) {
        localStorage.AUTH_TYPE = "TOOLKIT";
        const mateToken = jsBridge.call("toolkit.getTokenSyn").data.token
        appAuth(mateToken,1).then(() => {
            jsBridge.call("toolkit.titleBarSyn", "toolkit://title.bar?title=Help");
            if(!from.name) userInfoMTA()
            if (
                to.name === "home" ||
                to.name === "favorites" ||
                to.name === "message" ||
                to.name === "mine"
            ) {
                store.commit("RENDER_FIXED_BAR", true);
            } else {
                store.commit("RENDER_FIXED_BAR", false);
            }
            store.commit('SET_AUTH')
            GetDebugAuthUrl()
            next();
        });
        return;
    }


    // Wechat AUTH
    if (isWeixinCient() || process.env.NODE_ENV === 'development' ) {
        localStorage.AUTH_TYPE = "WECHAT";
        userAuth().then(() => {
            if (to.meta.title) {
                document.title = to.meta.title;
            } else document.title = "Help";
            if(!from.name) userInfoMTA()
            if (
                to.name === "home" ||
                to.name === "favorites" ||
                to.name === "message" ||
                to.name === "mine"
            ) {
                store.commit("RENDER_FIXED_BAR", true);
            } else {
                store.commit("RENDER_FIXED_BAR", false);
            }

            store.commit('SET_AUTH')
            GetDebugAuthUrl()
            next();
        });
        return;
    }


    // 接入Apollo文档 uds@2018 http://showdoc.nevint.com/index.php?s=/urm&page_id=8131
    dsBridge.call("ApolloApp.invokeAsyn", {methodName: "getSsoToken"}, function(res) {
        let _res = JSON.parse(res);
        // 用返回的 token 获取用户信息
        localStorage.AUTH_TYPE = "APOLLO";
        const apolloToken = _res.data.token
        appAuth(apolloToken, 3).then(() => {
            // 设置title
            dsBridge.call("ApolloApp.invokeAsyn", {
                methodName: "controlTitle",
                params: {
                    visible: true,
                    title: "Help"
                }
            });
            // 去除原生水印
            dsBridge.call('ApolloApp.invokeAsyn',{
                methodName: "showWaterMark",
                params: {
                    visible: false
                }
            });
            // 设置退出应用的时候不删除Local信息
            dsBridge.call('ApolloApp.invokeAsyn', {
                methodName: "clearCacheOnDestroy",
                params: {
                    isClearCache: false
                }
            });

            if(!from.name) userInfoMTA()
            if (
                to.name === "home" ||
                to.name === "favorites" ||
                to.name === "message" ||
                to.name === "mine"
            ) {
                store.commit("RENDER_FIXED_BAR", true);
            } else {
                store.commit("RENDER_FIXED_BAR", false);
            }
            store.commit('SET_AUTH')
            GetDebugAuthUrl()
            next();
        },()=>{
            next(false)
        });
        return
    });


    // 在以上三环境之外 都提示在微信客户端打开
    // if (!isApollo) {
        // alert(222)
        // location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=appid'
    // }
    
});
export default ROUTE;



// WEBPACK FOOTER //
// ./src/router/index.js